module.exports = __webpack_public_path__ + "img/identity.eca0df3b.png";